import { motion } from "framer-motion";

export const Reveal = ({ children, delay = 0, className, y = 28 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.12 }}
    transition={{ duration: 0.8, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

const Eyebrow = ({ children, className = "mb-4" }) => (
  <p className={`${className} flex items-center gap-2 font-mono-ph text-xs uppercase tracking-[0.22em] text-ph-accent`}>
    <span className="h-1.5 w-1.5 rounded-full bg-ph-lime shadow-[0_0_10px_rgba(182,255,92,0.8)]" /> {children}
  </p>
);

export const SectionHead = ({ eyebrow, title, desc, action, id }) => (
  <Reveal className="mb-10 flex flex-col gap-6 md:mb-14 md:flex-row md:items-end md:justify-between">
    <div className="max-w-2xl">
      {eyebrow && <Eyebrow>{eyebrow}</Eyebrow>}
      <h2 id={id} className="font-display text-3xl font-extrabold leading-[1] tracking-[-0.03em] text-ph-ink sm:text-4xl lg:text-5xl">
        {title}
      </h2>
      {desc && <p className="mt-5 text-base text-ph-muted md:text-lg">{desc}</p>}
    </div>
    {action}
  </Reveal>
);

export const PageIntro = ({ eyebrow, title, desc }) => (
  <section className="relative overflow-hidden pb-10 pt-36 md:pb-14 md:pt-44">
    <div className="ph2-grid absolute inset-0 -z-10" />
    <div className="ph2-orb absolute -left-24 top-10 -z-10 h-80 w-80 rounded-full bg-ph-violet/15 blur-[110px]" />
    <div className="mx-auto max-w-7xl px-5 md:px-8">
      <Eyebrow className="mb-5">{eyebrow}</Eyebrow>
      <h1 className="font-display text-5xl font-extrabold leading-[0.92] tracking-[-0.035em] text-ph-ink sm:text-6xl lg:text-7xl">
        {String(title).split("\n").map((line, i) => (
          <span key={line} className="block overflow-hidden pb-1">
            <motion.span className="block" initial={{ y: "105%" }} animate={{ y: 0 }} transition={{ duration: 0.9, delay: 0.1 + i * 0.12, ease: [0.22, 1, 0.36, 1] }}>
              {line}
            </motion.span>
          </span>
        ))}
      </h1>
      {desc && (
        <motion.p initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.7, delay: 0.35 }} className="mt-6 max-w-2xl text-base text-ph-muted md:text-lg">
          {desc}
        </motion.p>
      )}
    </div>
  </section>
);
